import { ModalContext } from "app/app";
import { FieldInput } from "components/fieldInput";
import { Icon } from "components/lib";
import { Form, Formik } from "formik";
import { Fragment, useContext, useState } from "react";
import * as Yup from "yup";
import Loader from "./images/loader.gif";
import styles from "./styles.module.scss";

export function ContestModal(props) {
  const { modal, setModal } = useContext(ModalContext);
  const [loading, setLoading] = useState(false);

  const api_error = false;

  const validationSchema = Yup.object().shape({
    goal: Yup.string().required("This field is required!"),
    prize: Yup.string().required("This field is required!"),
  });

  return (
    <Fragment>
      {modal.name === "contest_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              <div className={styles.title}>Add/Edit Contest</div>
              <div className={styles.line} />
              <Formik
                validationSchema={validationSchema}
                initialValues={{
                  goal: "",
                  prize: "",
                }}
                onSubmit={(values) => {
                  setLoading(true);

                  setTimeout(() => {
                    setLoading(false);
                    setModal("");
                  }, 2000);
                }}
              >
                {({
                  errors,
                  touched,
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  submitForm,
                }) => (
                  <Fragment>
                    <Form className={styles.form} onSubmit={handleSubmit}>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="goal"
                          type="text"
                          label="Goal"
                          placeholder="Insert goal"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.goal}
                          touched={touched.goal}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="prize"
                          type="text"
                          label="Prize"
                          placeholder="Insert prize"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          errors={errors.prize}
                          touched={touched.prize}
                          required
                        />
                      </div>
                      <div className={styles.fieldRow}>
                        <FieldInput
                          id="prize_photo"
                          type="upload"
                          label="Upload Prize Photo"
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          showErrors
                          required
                        />
                      </div>
                    </Form>
                    <div
                      className={styles.footer}
                      style={
                        api_error
                          ? { justifyContent: "space-between" }
                          : { justifyContent: "flex-end" }
                      }
                    >
                      {api_error && (
                        <div className={styles.errorMessage}>
                          <div className={styles.icon}>
                            <Icon image="alert-circle" />
                          </div>
                          <span>Something went wrong, check the fields.</span>
                        </div>
                      )}
                      <div className={styles.buttons}>
                        <button
                          className={styles.cancel}
                          onClick={() => setModal("")}
                        >
                          Cancel
                        </button>
                        <button className={styles.save} onClick={submitForm}>
                          {loading ? (
                            <img
                              src={Loader}
                              alt="Loader"
                              className={styles.loader}
                            />
                          ) : (
                            "Save"
                          )}
                        </button>
                      </div>
                    </div>
                  </Fragment>
                )}
              </Formik>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
